import { Actors } from '@/types/actors'

type GetUserRoleLabelParams = {
  isAdmin?: boolean
  isManager?: boolean
  role?: string
}

const ROLE_LABELS = {
  admin: 'Administrador',
  manager: 'Gestor',
  managerAdmin: 'Gestor, Admin',
  collaborator: 'Colaborador',
}

export function getUserRoleLabel({
  isAdmin = false,
  isManager = false,
  role,
}: GetUserRoleLabelParams): string {
  if (isAdmin && isManager) return ROLE_LABELS.managerAdmin
  if (isAdmin) return ROLE_LABELS.admin
  if (isManager) return ROLE_LABELS.manager

  if (role === Actors.MANAGER) return ROLE_LABELS.manager
  if (role === Actors.IDEATOR) return ROLE_LABELS.collaborator

  return ROLE_LABELS.collaborator
}
